import { GridColDef } from '@mui/x-data-grid';
import { TStudentPrimary } from '../../../../../apis/students/students.interfaces';
import { formatDateForSubmit } from '../../../../../utils/helpers';

export const getStudentGridRowsToRender = (records: TStudentPrimary[]) => {
  return records;
};

export const getColumnsForStudentGrid = (
  translateText: (key: string) => string
): GridColDef[] => {
  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: translateText('students.studentList.columns.name'),
      width: 160,
      renderCell: (params) => {
        const data = params.row as TStudentPrimary;
        return `${data.basicDetails.firstName} ${data.basicDetails.middleName} ${data.basicDetails.lastName}`;
      },
    },
    {
      field: 'admissionDate.timestamp',
      headerName: translateText('students.studentList.columns.admittedOn'),
      width: 130,
      renderCell: (params) => {
        const data = params.row as TStudentPrimary;
        return `${formatDateForSubmit(data?.admissionDate?.timestamp) ?? '---'
          }`;
      },
    },
    {
      field: 'grade',
      headerName: translateText('students.studentList.columns.class'),
      width: 100,
      renderCell: (params) => {
        const data = params.row as TStudentPrimary;
        return `${data?.grade ?? '---'}`;
      },
    },
    {
      field: 'section',
      headerName: translateText('students.studentList.columns.section'),
      width: 100,
      renderCell: (params) => {
        const data = params.row as TStudentPrimary;
        return `${data?.section ?? '---'}`;
      },
    },
    {
      field: 'contactDetails.phone',
      headerName: translateText('students.studentList.columns.phone'),
      width: 200,
      renderCell: (params) => {
        const data = params.row as TStudentPrimary;
        return `${data?.contactDetails?.phone?.countryCode} ${data?.contactDetails?.phone?.phoneNumber
          } (${data?.contactDetails?.phone?.isVerified ? 'Verified' : 'Not Verified'
          })`;
      },
    },
    {
      field: 'contactDetails.email',
      headerName: translateText('students.studentList.columns.email'),
      width: 200,
      renderCell: (params) => {
        const data = params.row as TStudentPrimary;
        return `${data?.contactDetails?.email?.email ?? data?.contactDetails?.email ?? '---'}`;
      },
    },
  ];
  return columns;
};
